import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export enum PersistentMapActionType {
    GetValues = 0,
    SetValues = 1,
    EraseKey = 2,
    Clear = 3,
}

export type IPersistentMapSetValues = Array<{ key: string; value: string }>
export type IPersistentMapEraseKey = string

export async function persistentMapAction(
    clientId: IClientUID,
    type: PersistentMapActionType,
    data?: IPersistentMapSetValues | IPersistentMapEraseKey,
): Promise<ApiResponse<void>> {
    const response = await fetch(`${HOST_URL}persistent-map`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, type, data }),
    })
    const result = (await response.json()) as any
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
